// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsBsdControl_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.02669 15.0948 2.02682 15.0926 10.0126 15.5766 12.0076 15.7188C12.1314 13.7084 13.7401 12.0997 15.7505 11.976L15.6257 9.97982 15.6157 9.98045 14.9963 0C6.95467.494946.525289 6.92831.0305156 14.97L2.02669 15.0948ZM10.4849 13.6015 2.29284 13.105C3.42048 7.67798 7.69002 3.40226 13.1138 2.26557L13.6418 10.4495C12.2271 11.0548 11.0923 12.188 10.4849 13.6015ZM16.9052 1.99617 16.9074 1.99631 16.4234 9.98206 16.2812 11.9771C18.2916 12.1009 19.9003 13.7096 20.024 15.72L22.0202 15.5952 22.0196 15.5851 32 14.9658C31.5051 6.92415 25.0717.494774 17.03 0L16.9052 1.99617ZM18.3985 10.4543 18.8949 2.26233C24.322 3.38997 28.5977 7.6595 29.7344 13.0833L21.5505 13.6112C20.9452 12.1966 19.812 11.0617 18.3985 10.4543ZM30.0037 16.9074 30.0038 16.9052 32 17.03C31.5052 25.0717 25.0758 31.5051 17.0342 32L16.4149 22.0196 16.4048 22.0202 16.28 20.024C18.2904 19.9003 19.8991 18.2916 20.0229 16.2812L22.0179 16.4234 30.0037 16.9074ZM29.7377 18.895 21.5457 18.3985C20.9383 19.812 19.8034 20.9452 18.3887 21.5505L18.9167 29.7344C24.3405 28.5977 28.61 24.322 29.7377 18.895ZM15.0948 30.0038 15.0926 30.0037 15.5766 22.0179 15.7188 20.0229C13.7084 19.8991 12.0997 18.2904 11.976 16.28L9.97982 16.4048 9.98045 16.4149 0 17.0342C.494945 25.0758 6.9283 31.5052 14.97 32L15.0948 30.0038ZM13.6015 21.5457 13.105 29.7377C7.67798 28.61 3.40226 24.3405 2.26557 18.9167L10.4495 18.3888C11.0548 19.8034 12.188 20.9383 13.6015 21.5457Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsBsdControl is a generated icon component.
 */
let IconRmsBsdControl = IconRmsBsdControl_1 = class IconRmsBsdControl extends IconBaseElement {
    render() {
        return html `${IconRmsBsdControl_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsBsdControl.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconRmsBsdControl = IconRmsBsdControl_1 = __decorate([
    customElement('zui-icon-rms-bsd-control')
], IconRmsBsdControl);
export { IconRmsBsdControl };
